import resolver, {ResolverSettings} from './utils/resolver';
import {GetGuestSchemaPayload, GuestSchemaResponse} from '../services';
import {Guest} from '../utils/types';

type CreateGuestWithMinDataPayload = Pick<Guest, 'name' | 'surname'> & {
  reservation_id?: string;
};

class GuestApi {
  ENDPOINTS = {
    all: (id = '') => `guests/${id ? `${id}/` : ``}`,
    one: (id: string, params = '') => `guests/${id}/${params}`,
    oneV4: (id: string, params = '') => `guestapp/guests/${id}/${params}`,
    getSchema: () => `guestapp/guests/schema/`,
    delete: (id: string) => `guests/${id}/`,
    create: (params = '') => `guestapp/guests/${params}`,
    patch: (id: string) => `guestapp/guests/${id}/`,
  };

  getOne(id: string, resolverSettings?: ResolverSettings) {
    return resolver<Guest>(
      this.ENDPOINTS.oneV4(id),
      {
        method: 'GET',
      },
      {version: 4, ...resolverSettings},
    );
  }

  create(payload: FormData, resolverSettings?: ResolverSettings) {
    return resolver<Guest>(
      this.ENDPOINTS.create(),
      {
        method: 'POST',
        body: payload,
        headers: {},
      },
      {version: 4, ...resolverSettings},
    );
  }

  createMin(payload: CreateGuestWithMinDataPayload, resolverSettings?: ResolverSettings) {
    return resolver<Guest>(
      this.ENDPOINTS.create('?min=true'),
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      {version: 4, ...resolverSettings},
    );
  }

  patch(id: string, payload: FormData, resolverSettings?: ResolverSettings) {
    return resolver<Guest>(
      this.ENDPOINTS.patch(id),
      {
        method: 'PATCH',
        body: payload,
        headers: {},
      },
      {version: 4, ...resolverSettings},
    );
  }

  delete(id: string, resolverSettings?: ResolverSettings) {
    return resolver(
      this.ENDPOINTS.delete(id),
      {
        method: 'DELETE',
      },
      resolverSettings,
    );
  }

  getSchema(payload: GetGuestSchemaPayload, resolverSettings?: ResolverSettings) {
    return resolver<GuestSchemaResponse>(
      this.ENDPOINTS.getSchema(),
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      {version: 4, ...resolverSettings},
    );
  }
}

export {GuestApi};
export type {CreateGuestWithMinDataPayload};
